import React from "react";
import BusinessReviews from "./BusinessReviews";
import RatingStars from "../../../../components/common/RatingStars/RatingStars";
import PosterRanking from "../../../PosterProfile/PosterRanking";
import {
  AdminSectionTitle,
  AdminMetric,
  AdminMetadataText,
} from "../../../AdminDashboard/shared/adminUx";

const ReviewsLayout = () => {
  const ReviewItems = [
    { text: "Communication" },
    { text: "Reliability" },
    { text: "Satisfaction" },
    { text: "Recommend" },
    { text: "Punctuality" },
  ];

  return (
    <div className="grid grid-cols-12 w-full">
      <div className="col-span-12">
        <div className="hidden">
          <div className="mt-10 md:mt-0">
            <div className="bg-white lg:bg-pastalblue text-offblack rounded-2xl px-10 md:px-20 py-10">
              <div className="flex justify-between mb-5">
                <AdminSectionTitle className="text-offblack">Overall rating</AdminSectionTitle>
                <div className="flex items-center gap-3 h-[20px]">
                  <AdminMetric size="large" className="text-offblack">
                    4.1
                  </AdminMetric>
                </div>
              </div>
              {ReviewItems.map((item) => (
                <div key={item.text} className="flex items-center justify-between mt-1">
                  <AdminMetadataText className="text-mediumgray">{item.text}</AdminMetadataText>
                  <RatingStars rating={3} />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="hidden">
          <PosterRanking show={true} />
        </div>

        <BusinessReviews
          showMeReply={false}
          showMeReport={false}
          DropdownClasses="bg-white border border-mistgray"
        />
      </div>
    </div>
  );
};

export default ReviewsLayout;
